module.exports = __webpack_public_path__ + "img/liquidity.208cf598.svg";